.wrap {
  position: relative;
  display: flex;
  min-width: 0;
}

.chip {
  display: inline-flex;
  flex: none;
  gap: 6px;
  align-items: center;
  max-width: 260px;
  padding: 5px 10px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 7px;
}

.chipButton {
  cursor: pointer;
}

.chipButton:hover {
  border-color: var(--text-brand);
}

/* Вид узкого экрана: на 1024 белая плашка теряется среди белой шапки, а филиал —
   единственное, чего нельзя перепутать. */
.chipFilled {
  color: var(--text-on-nav-active);
  background: var(--bg-nav);
  border-color: var(--bg-nav);
}

.chipLabel {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.caret {
  flex: none;
  opacity: 0.7;
}

.search {
  width: 100%;
  padding: 6px 11px;
  margin-bottom: 6px;
  font-family: var(--font-ui);
  font-size: var(--font-size-md);
  color: var(--text-primary);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
}

.all {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  width: 100%;
  padding: 8px 10px;
  margin-bottom: 6px;
  font-family: var(--font-ui);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
  text-align: left;
  cursor: pointer;
  background: none;
  /* Пунктир отличает «Все филиалы» от настоящей точки: это режим, а не адрес. */
  border: 1px dashed var(--border-strong);
  border-radius: 7px;
}

.all:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.allNote {
  margin-left: auto;
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-medium);
  color: var(--text-secondary);
  text-align: right;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 1px;
  max-height: 46vh;
  overflow-y: auto;
}

.item {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  width: 100%;
  padding: 7px 10px;
  font-family: var(--font-ui);
  font-size: var(--font-size-md);
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
  background: none;
  border: 0;
  border-radius: 7px;
}

.item:hover {
  background: var(--bg-sunken);
}

.itemCurrent {
  background: var(--bg-sunken);
}

.itemName {
  min-width: 0;
  overflow: hidden;
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.zone {
  flex: none;
  margin-left: auto;
  font-size: var(--font-size-2xs);
  white-space: nowrap;
}

/* Свой пояс подписан тихо, чужой — заметно и весом. Разница в часах это единственное,
   что человек обязан заметить в этом списке. */
.zoneSame {
  font-weight: var(--font-weight-regular);
  color: var(--text-faint);
}

.zoneOther {
  font-weight: var(--font-weight-semibold);
  color: var(--status-pending-fg);
}

.empty {
  padding: 10px;
  margin: 0;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
}
